<template>
	<!-- 批量删除 -->
	<div class="flex-row-center-start ml-20 h-32 pointer" @click="Operate">
		<img class="wh-20" src="@/assets/icon_14.png" alt="">
		<span class="fz-14 color-primary ml-8">{{ translate.ShowText('删除') }}</span>
	</div>
</template>

<script lang="ts" setup>
	import translate from '@/api/translate';

	const emits = defineEmits(["change"]);

	const Operate = () => {
		emits("change");
	};
</script>

<style>
</style>